import { createSlice } from '@reduxjs/toolkit';
import userData from 'tradera/apps/syi/services/user-data';
import config from 'tradera/apps/syi/services/config';

const setValidationError = (condition: boolean | undefined) =>
    condition ? 'syi_summary_terms_active_consent_missing_error' : null;

const validate = (state: MemberConsentState) => {
    return {
        ...state,
        validationError: setValidationError(!state.hasTraderaPayConsent),
    };
};

type MemberConsentState = {
    isUnderLicense?: boolean;
    hasTraderaPayConsent?: boolean;
    initalConsentGiven?: boolean;
    shouldGiveConsent?: boolean;
    needsConsentOfTraderaPayAgreement?: string;
    signatoryVerificationRequired?: boolean;
    validationError?: string | null;
};

const createInitalState = (): MemberConsentState => {
    if (!userData || !userData.consent || !userData.braintree) {
        // seems syi is not loaded, return empty object
        return {};
    }
    // Companies need to verify signatory when consent to money transfer license.
    // And this is not possible on SYI and should therefor not be shown or validated.
    const shouldBypassConsent = userData.consent.signatoryVerificationRequired;

    const shouldGiveConsent = config.isSyiMemberConsentEnabled;
    const hasTraderaPayConsent = !!userData.consent.hasTraderaPayConsent;
    const needsConsentOfTraderaPayAgreement =
        userData.consent.needsConsentOfTraderaPayAgreement;
    const hasValidationError =
        shouldGiveConsent &&
        !shouldBypassConsent &&
        !userData.consent.hasTraderaPayConsent;

    return {
        isUnderLicense: userData.consent.isUnderLicense,
        hasTraderaPayConsent,
        initalConsentGiven: hasTraderaPayConsent,
        shouldGiveConsent,
        needsConsentOfTraderaPayAgreement,
        signatoryVerificationRequired:
            userData.consent.signatoryVerificationRequired,
        validationError: setValidationError(hasValidationError),
    };
};

const initialState = createInitalState();

const memberConsentSlice = createSlice({
    name: 'memberConsent',
    initialState,
    reducers: {
        setTraderaPayConsent: (state, action) =>
            validate({
                ...state,
                hasTraderaPayConsent: action.payload,
            }),
    },
});

export const { setTraderaPayConsent } = memberConsentSlice.actions;
export default memberConsentSlice.reducer;
